import { render, staticRenderFns } from "./SurveyStatCard.vue?vue&type=template&id=2d117b67&scoped=true&"
import script from "./SurveyStatCard.vue?vue&type=script&lang=js&"
export * from "./SurveyStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d117b67",
  null
  
)

export default component.exports